module.exports = __webpack_public_path__ + "img/shecdule.e215c4c.png";